import React from "react";
import {Route} from "react-router-dom";
import {
  BreederList,
  BreederProfile,
  DogEdit,
  DogList,
  DogProfile,
  Home,
  LitterList,
  LitterProfile,
  OrganizationProfile,
  Privacy,
  Search,
  Terms,
} from "./lazyPages";

export const publicRoutes = (
  <>
    <Route index element={<Home />} />
    <Route path="privacy" element={<Privacy />} />
    <Route path="terms" element={<Terms />} />
    <Route path=":organizationPrefix/search" element={<Search />} />
    <Route path=":organizationPrefix/home" element={<OrganizationProfile />} />
    <Route path=":organizationPrefix/dogs" element={<DogList />} />
    <Route path=":organizationPrefix/breeders" element={<BreederList />} />
    <Route path=":organizationPrefix/litters" element={<LitterList />} />
    <Route path=":organizationPrefix/breeder/:breederId" element={<BreederProfile />} />
    <Route path=":organizationPrefix/dog/:id" element={<DogProfile />} />
    <Route path=":organizationPrefix/dog/edit/:id" element={<DogEdit />} />
    <Route path=":organizationPrefix/litter/:id" element={<LitterProfile />} />
  </>
);
